import BrokenLink from '../components/BrokenLinkView';

const BrokenLinkPage: React.FC<{}> = () => <BrokenLink />;

export default BrokenLinkPage;
